import { useEffect, useState } from "react";
import { Alert, AlertTitle } from "@mui/material";
import { getCurrentBanner } from "@/actions/bannerActions";
import { BannerContent } from "@/utils/types/banner";

const MaintenanceBanner = () => {
  const [banner, setBanner] = useState<BannerContent | null>(null);

  useEffect(() => {
    const getBannerAsync = async () => {
      let res: BannerContent | null = null;
      try {
        res = await getCurrentBanner();
      } catch (error) {
        console.error("Failed to get the current banner.");
        console.error(error);
        return;
      }
      if (res) {
        try {
          if (localStorage.getItem(`banner_${res.name}`) === "true") return;
        } catch {}
        setBanner(res);
      }
    };

    getBannerAsync();
  }, []);

  if (!banner) return null;

  const handleClose = () => {
    try {
      localStorage.setItem(`banner_${banner.name}`, "true");
    } catch {}
    setBanner(null);
  };

  return (
    <Alert
      severity="warning"
      variant="filled"
      onClose={handleClose}
      sx={{ pl: "266px", color: "#fff", borderRadius: 0 }}
    >
      <AlertTitle>{banner.title}</AlertTitle>
      {banner.content}
    </Alert>
  );
};

export default MaintenanceBanner;
